
import { all } from 'redux-saga/effects';
import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers'
import createSagaMiddleware from 'redux-saga';
import gameSessionWatchers from './gamesession.saga';

function* rootSaga(){
  yield all(gameSessionWatchers);
};

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

export { sagaMiddleware, store, rootSaga };